import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AgencyLink } from './styled';
import { ScheduleAndLocationBlock } from '../ScheduleAndLocationBlock';
import { OwnerAdditionalInfoWrapper } from '../blocks/OwnerContactsBlock/styled';

interface AgencyAdditionalInfoProps {
  linkPath: string;
  offersCount?: number;
  agencyInfo: ReactNode;
  schedule?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  city?: string | null;
}

export const AgencyAdditionalInfo: React.FC<AgencyAdditionalInfoProps> = ({
  linkPath,
  offersCount,
  agencyInfo,
  schedule,
  address,
  latitude,
  longitude,
  city
}) => {
  const { t } = useTranslation();

  return (
    <>
      <OwnerAdditionalInfoWrapper>
        {agencyInfo}
        <ScheduleAndLocationBlock
          address={address}
          latitude={latitude}
          longitude={longitude}
          schedule={schedule}
          city={city}
        />
      </OwnerAdditionalInfoWrapper>
      <AgencyLink href={linkPath} data-cy="phones-additional__btns-link-btn">
        {t('pages.current_item.buttons.show_offers', { count: offersCount })}
      </AgencyLink>
    </>
  );
};
